import * as React from 'react';
import {ChangeEvent, useEffect, useState} from 'react';
import {BounceLoader} from "../../BounceLoader";
import {baseUrlEmbrodery, fetchDataFilsExist} from "./EmbroderyUtils";
import {_getVariableNbCouleurs, _getFeatureNbCouleurs, _checkCanReUse} from "./embroidery.api";

interface BtnActionEmbroideryProps {
  idCommande:number,
  numCommande:string,
  surfaceId: number,
  emplacementId: number,
  fileRegisteredId:number,
  fileRegisteredCreationId: string,
  surfaceEmplacementId: number,
  isValidBroderie: boolean,
  customerView: boolean,
  needSetFilsBroderie: boolean,
  fetchFilsBroderie: (nbrFils?: number | null) => void;
  validerFilsBroderie: () => void;
  devaliderFilsBroderie: () => void;
  idBroderie: number | null;
  displayChargementBroderie: boolean;
  idCaddies: string;
  wantReUseFil: (want: boolean) => void;
  traitementContours: string;
  galerieFichierVariableId: number;
}

export const BtnActionEmbroidery = (props: BtnActionEmbroideryProps) => {
  const obtenirCouleursFils = props.needSetFilsBroderie && !props.isValidBroderie;
  const [isValidBroderie, setIsValidBroderie] = useState(props.isValidBroderie);
  const [idBroderie, setIdBroderie] = useState(props.idBroderie);
  const [broderieExist, setBroderieExist] = useState( _checkBroderieExist());
  const [displayChargement, setDisplayChargement] = useState(props.displayChargementBroderie);
  const [strTitle, setStrTitle] = useState(_setLibelleBtn());
  const [showFormNumberfils, setShowFormNumberfils] = useState(false);
  const [numberfils, setNumberfils] = useState(0);
  const [canSubmitNumberfils, setCanSubmitNumberfils] = useState(false);
  const [nbCouleursMax, setNbCouleursMax] = useState(0);
  const [activateNbCouleurs, setActivateNbCouleurs] = useState(false);
  const [canReUseFils, setCanReUseFils] = useState(false);
  const [canReUseFilsTxt, setCanReUseFilsTxt] = useState('');
  const [wantReUseFil, setWantReUseFil] = useState(false);
  const needNumberFils = _checkNeedNumberFils();


  useEffect(() => {
   if(props.displayChargementBroderie !== displayChargement) {
     setDisplayChargement(props.displayChargementBroderie);
   }
   if(idBroderie !== props.idBroderie) {
     setIdBroderie(props.idBroderie);
   }
   if(broderieExist !== _checkBroderieExist()) {
     setBroderieExist(_checkBroderieExist);
   }
   if(_setLibelleBtn() !== strTitle) {
     setStrTitle(_setLibelleBtn());
   }
   if(isValidBroderie !== props.isValidBroderie) {
     setIsValidBroderie(props.isValidBroderie);
   }
  });

  useEffect(() => {
    _getVariableNbCouleurs().then((response) => {
      if(response?.data?.variable?.valeur) {
        setNbCouleursMax(parseInt(response.data.variable.valeur));
      }
    });
    _getFeatureNbCouleurs().then((response) => {
      if(response?.data?.feature) {
        setActivateNbCouleurs(response.data.feature);
      }

    });
    const baseUrl = baseUrlEmbrodery(props.idCaddies,props.idCommande, props.surfaceId, props.emplacementId, props.fileRegisteredId );
    const url = fetchDataFilsExist(props.idCaddies, baseUrl, props.fileRegisteredCreationId, props.surfaceEmplacementId, props.traitementContours, props.galerieFichierVariableId);
    _checkCanReUse(url).then((response: any) => {
        if (response.data) {
          if (response.data.fils.length > 0) {
            const numcmd = props.numCommande.split("-")[2];
            const filsExistIncurrentCmd = numcmd === response.data.infosOldCmd.numCmd;
            const text = filsExistIncurrentCmd ? `Voulez vous récupérer les fils de votre commande en cours ?` : `Voulez vous récupérer les fils d'une ancienne commande "${response.data.infosOldCmd.numCmd}" du ${response.data.infosOldCmd.dateCommande} ?`
              // si filsExistIncurrentCmd on force à ré-utiliser les fils si alias = null ? #3447
              // setWantReUseFil(filsExistIncurrentCmd);
               setWantReUseFil(false);
              setCanReUseFils(true);
              setCanReUseFilsTxt(text);
            }
        }
      });

  }, []);

  useEffect(() => {
    const canSubmit = numberfils > 0 && numberfils <= nbCouleursMax && showFormNumberfils;
    if(canSubmit !== canSubmitNumberfils) {
      setCanSubmitNumberfils(canSubmit)
    }
  }, [numberfils]);

  function _checkBroderieExist() {
    return props.idBroderie && props.idBroderie > 0;
  }

  function _checkNeedNumberFils() {
    return ((props.needSetFilsBroderie && !props.isValidBroderie) && !(props.idBroderie && props.idBroderie > 0));
  }

  function _setLibelleBtn() {
    let strTitle = _checkNeedNumberFils() ? 'Obtenir les couleurs de fils' : 'Valider les couleurs de fils';
    strTitle = props.isValidBroderie && props.idBroderie && props.idBroderie > 0 ? 'Dévalider les couleurs de fils' : strTitle;
    return strTitle;
  }

  function nbrFilsControls(event: ChangeEvent<HTMLInputElement>) {
    const newValue = parseInt(event.target.value,10);
    setNumberfils(newValue);
  }

  function validReUseFils() {
    setShowFormNumberfils(!showFormNumberfils);
    props.wantReUseFil(true);
    props.fetchFilsBroderie();
  }


  function onClick() {
    if(broderieExist) {
      if(isValidBroderie) {
        props.devaliderFilsBroderie();
      } else {
        props.validerFilsBroderie();
      }
    } else if(obtenirCouleursFils) {
      if(wantReUseFil) {
        props.wantReUseFil(wantReUseFil);
        props.fetchFilsBroderie();
      } else if(needNumberFils &&  activateNbCouleurs && !showFormNumberfils){
        setShowFormNumberfils(!showFormNumberfils);
      } else if(needNumberFils &&  activateNbCouleurs && showFormNumberfils && canSubmitNumberfils) {
        setShowFormNumberfils(!showFormNumberfils);
        props.fetchFilsBroderie(numberfils);
      } else if(!needNumberFils) {
        props.fetchFilsBroderie();
      }
    }
  }
  return (
    <>
      {showFormNumberfils ? (
        <div className={` bold text-center py-4 px-4 w-100 mb-0 alert alert-warning`}>
          {canReUseFils && canReUseFilsTxt !== '' ? (
            <>
              {canReUseFilsTxt}
              <div className={'d-flex justify-content-center mt-2'}>
              <button  onClick={() => setCanReUseFils(!canReUseFils)} className={`btnBatAuto cursor-pointer bold text-center py-4 px-4 mr-3`}>Non</button>
              <button  onClick={() => validReUseFils()} className={`btnBatAuto cursor-pointer bold text-center py-4 px-4 ml-3 btnBatAutoBat`}>Oui</button>
              </div>
            </>
          ) : (
            <>
              Saisissez le nombre de couleurs du visuel : <input className={'mx-2 text-center'} onChange={nbrFilsControls} required={true} value={numberfils}
                                                             type={'number'} min={1} max={nbCouleursMax}/> <span className={'italic'}>({nbCouleursMax} couleurs maximum)</span>
          <button disabled={!canSubmitNumberfils}  onClick={onClick} className={`btnBatAuto cursor-pointer bold text-center py-4 px-4 ml-2`}>Valider</button>
            </>
            )}
        </div>
        ) : (
        <button disabled={displayChargement} className={`btnBatAuto cursor-pointer bold text-center py-4 px-4 w-100   ${props.isValidBroderie && props.idBroderie && props.idBroderie > 0 ? 'mt-4' : 'btnBatAutoBat'}`}  onClick={onClick} >
        {displayChargement ? (
        <BounceLoader loading={displayChargement} />
          ) : (
            <span className={'bold'}>
               {strTitle}
            </span>
          )}
      </button>
        )}
    </>
  );
}